export class CancelItem {
    id = 0;
    constructor(id) {
        this.id = id;
    }
    createReqBody() {
        return this.id;
    }
}
